import { useSelector } from 'react-redux';

export default function useIsMobile() {
  const screen = useSelector(state => state.app?.screen);
  return screen === 'mobile';
}
